module.exports = __webpack_public_path__ + "static/img/iPhone13.6c80952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iPhone13.png
// module id = 68QB
// module chunks = 0